import { UserRemove } from '@/shared/svgs';
import s from '@/components/orders/new-order/live.module.css';

export const SelectedShopChip = ({ isOperating, isMasterOrAdmin, selectedShop, onRemoveShop }) => {
	if (!isOperating || !isMasterOrAdmin) return null;

	if (!selectedShop) return <div className={s.selectShopContainer} />;

	return (
		<div className={s.shopContainer}>
			<div className={s.editRemoveIcons}>
				<UserRemove onClick={onRemoveShop} />
			</div>
			<div className={s.selectedShopDetails}>
				{`${selectedShop.name}, ${selectedShop.address?.name}, ${selectedShop.phone}`}
			</div>
		</div>
	);
};
